import axios from "axios";
import { API_LIST_STATES_BY_CATEGORY } from "../context/CampaignContext/static";
import { Especialidade } from "./AxiosRequestEspecialidade";

export class AxiosRequestUF {
  async get (especialidade: Especialidade): Promise<string[]> {
    const params = {
      codigoCategoria: especialidade.Codigo
    }
    const response = await axios.get(API_LIST_STATES_BY_CATEGORY, { params });
    return response.data.ObjetoRetorno.map((o:any) => o as string);
  }
}